// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ee08b55d","732":"bc91a884","977":"b70771d7"}[chunkId] + ".chunk.js";
};